import { render, staticRenderFns } from "./BaixasAlugueis.vue?vue&type=template&id=5d255852&scoped=true&"
import script from "./baixasAlugueis.js?vue&type=script&lang=js&"
export * from "./baixasAlugueis.js?vue&type=script&lang=js&"
import style0 from "./BaixasAlugueis.vue?vue&type=style&index=0&id=5d255852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d255852",
  null
  
)

export default component.exports